(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimony"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('testimonialSlider');
  if (!slider) return;

  // Only apply slider behavior for tablet/mobile
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  if (isDesktop) return;

  const items = slider.querySelectorAll('.testimonies__item');
  if (items.length <= 1) return; // No need for slider with 1 item

  // Clone first item and append to end for infinite loop
  const firstItem = items[0].cloneNode(true);
  firstItem.classList.add('clone');
  slider.appendChild(firstItem);

  let currentIndex = 0;
  const itemWidth = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  let isAnimating = false;
  let autoScrollInterval;

  function goToSlide(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.style.scrollBehavior = 'smooth';
    slider.scrollTo({
      left: index * itemWidth,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      // If we're at the clone, instantly reset to first item without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
      }
      isAnimating = false;
    }, 500);
  }

  function startAutoScroll() {
    autoScrollInterval = setInterval(() => {
      currentIndex++;
      goToSlide(currentIndex);
    }, 3000);
  }

  // Start auto-scrolling
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', () => {
    clearInterval(autoScrollInterval);
  });

  slider.addEventListener('mouseleave', () => {
    startAutoScroll();
  });

  // Handle touch events
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    clearInterval(autoScrollInterval);
  }, {passive: true});

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
    startAutoScroll();
  }, {passive: true});

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      // Swipe left - next slide
      currentIndex++;
      goToSlide(currentIndex);
    } else if (touchEndX - touchStartX > threshold) {
      // Swipe right - previous slide
      currentIndex = Math.max(0, currentIndex - 1);
      goToSlide(currentIndex);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  const observerOptions = { threshold: 0.1 };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
      }
    });
  }, observerOptions);
  document.querySelectorAll('[data-fade]').forEach(el => observer.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-treatments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var targets = section.querySelectorAll('.fade-in-target');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["house-feature"] && !Shopify.designMode) return;
  try {
    
  function initParallaxHouse() {
    const section = document.querySelector('.js-parallax-section');
    const imgUp = document.querySelector('.js-parallax-up');
    const imgDown = document.querySelector('.js-parallax-down');

    if (!section || !imgUp || !imgDown) return;

    const handleScroll = () => {
      const sectionRect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionCenter = sectionRect.top + (sectionRect.height / 2);
      const viewportCenter = windowHeight / 2;
      const distanceFromCenter = viewportCenter - sectionCenter;

      if (sectionRect.top < windowHeight && sectionRect.bottom > 0) {
        const speed = 0.15;
        const movement = distanceFromCenter * speed;
        imgUp.style.transform = `translateY(${-movement}px)`;
        imgDown.style.transform = `translateY(${movement}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  document.addEventListener('DOMContentLoaded', initParallaxHouse);
  document.addEventListener('shopify:section:load', initParallaxHouse);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    var s = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!s) return;
    var grid = s.querySelector('.g-coll__grid');
    s.querySelectorAll('.g-coll__view-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        s.querySelectorAll('.g-coll__view-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (grid) grid.setAttribute('data-grid-view', btn.getAttribute('data-view'));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-gp-root][data-section-id="{{ section.id }}"]');
    if (!root) return;

    var thumbs = root.querySelectorAll('[data-gp-thumb]');
    var heroes = root.querySelectorAll('[data-gp-hero]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-gp-thumb');
        thumbs.forEach(function (b) {
          var on = b === t;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        heroes.forEach(function (h) {
          h.classList.toggle('is-active', h.getAttribute('data-gp-hero') === idx);
        });
      });
    });

    var variantsScript = root.querySelector('[data-gp-variants]');
    var variantInput   = root.querySelector('[data-gp-variant-id]');
    var addBtn         = root.querySelector('[data-gp-add]');
    var addLabel       = root.querySelector('[data-gp-add-label]');
    var priceEl        = root.querySelector('[data-gp-price]');
    var optGroups      = root.querySelectorAll('[data-gp-opt-index]');
    var variants       = [];
    try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]'); } catch (e) {}

    function currentSelection() {
      var sel = [];
      optGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-gp-opt-index'), 10);
        var active = group.querySelector('.gp__pill.is-active');
        sel[idx] = active ? active.getAttribute('data-gp-opt-value') : null;
      });
      return sel;
    }
    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < sel.length; j++) {
          if (v.options[j] !== sel[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
    function refreshState() {
      var sel = currentSelection();
      var v = findVariant(sel);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Indisponible';
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_money;
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
    }

    optGroups.forEach(function (group) {
      group.querySelectorAll('.gp__pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.gp__pill').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
          refreshState();
        });
      });
    });

    var accRoot = root.querySelector('[data-gp-accordion]');
    if (accRoot) {
      var items = accRoot.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) {
            items.forEach(function (other) { if (other !== d) other.open = false; });
          }
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;
    var tabs = section.querySelectorAll('.pgt__tab');
    var panels = section.querySelectorAll('.pgt__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.id === target);
        });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('productSlider');
  if (!slider) return;

  const items = slider.querySelectorAll('.product-card');
  if (items.length <= 1) return;

  // Clone items for infinite loop
  const cloneCount = Math.min(3, items.length);
  for (let i = 0; i < cloneCount; i++) {
    const clone = items[i].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    slider.appendChild(clone);
  }

  let currentIndex = 0;
  let isAnimating = false;
  let autoScrollInterval;
  let scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);

  // Update scroll amount on resize
  window.addEventListener('resize', () => {
    scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  });

  function scrollToIndex(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.scrollTo({
      left: index * scrollAmount,
      behavior: 'smooth'
    });

    setTimeout(() => {
      // If we're at the clones, instantly reset without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
        setTimeout(() => {
          slider.style.scrollBehavior = 'smooth';
        }, 50);
      }
      isAnimating = false;
    }, 500);
  }

  function scrollNext() {
    currentIndex++;
    scrollToIndex(currentIndex);
  }

  function scrollPrev() {
    currentIndex = Math.max(0, currentIndex - 1);
    scrollToIndex(currentIndex);
  }

  // Auto-scroll every 3 seconds
  function startAutoScroll() {
    autoScrollInterval = setInterval(scrollNext, 2500);
  }

  function stopAutoScroll() {
    clearInterval(autoScrollInterval);
  }

  // Initialize auto-scroll
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', stopAutoScroll);
  slider.addEventListener('mouseleave', startAutoScroll);
  slider.addEventListener('touchstart', stopAutoScroll, { passive: true });
  slider.addEventListener('touchend', startAutoScroll, { passive: true });

  // Arrow controls
  document.querySelector('.slider-arrow.left').addEventListener('click', scrollPrev);
  document.querySelector('.slider-arrow.right').addEventListener('click', scrollNext);

  // Touch swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      scrollNext();
    } else if (touchEndX - touchStartX > threshold) {
      scrollPrev();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;
    var input = section.querySelector('.sl__input');
    var items = section.querySelectorAll('.sl__item');
    var emptyState = section.querySelector('.sl__empty-state');
    if (!input) return;

    input.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();
      var matched = 0;
      items.forEach(function (item) {
        var name = item.getAttribute('data-name') || '';
        var city = item.getAttribute('data-city') || '';
        var hit  = !q || name.indexOf(q) !== -1 || city.indexOf(q) !== -1;
        item.style.display = hit ? '' : 'none';
        if (hit) matched++;
      });
      if (emptyState) emptyState.hidden = matched > 0;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treatment-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;
    var track = section.querySelector('.tc__track');
    var prev  = section.querySelector('.tc__nav--prev');
    var next  = section.querySelector('.tc__nav--next');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.querySelector('.tc__slide');
      if (!first) return 320;
      var styles = getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || 0, 10) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
